module.exports = __webpack_public_path__ + "static/carousel-1-5e85e02adcd84120f5c5bbda2f6f2f4e.png";